  document.addEventListener('DOMContentLoaded', function() {
    new Splide('#top-bar-splide', {
      type: 'loop',
      perPage: 1,
      gap: 0,
      pagination: false,
      arrows: false,
      autoplay: true,
        mediaQuery: 'min',
        breakpoints: {
                960: {
                    destroy: true,
                },
        }
    }).mount();
  });